export default __webpack_public_path__ + "static/knots-0b1a0953d0eb273ee8199e2a316093fc.svg";